class SimpleEvent {
  constructor(id, permalink, eventCategories, date, img, dateObj, time = {}, title, excerpt, long_excerpt, color, repeated, categories = []) {
    this.id = id;
    this.permalink = permalink;
    this.eventCategories = eventCategories;
    this.date = date;
    this.img = img;
    this.dateObj = dateObj;
    this.time = time;
    this.excerpt = excerpt;
    this.long_excerpt = long_excerpt;
    this.title = title;
    this.color = color;
    this.repeated = repeated;
    this.categories =
      [
        {
          color: "blue",
          title: "hi",
        },
      ] || categories;
  }

  getEvent() {
    return this;
  }
}
class SimpleEventCategory {

  constructor(color, title) {
    this.color = color;
    this.title = title;
  }

  // constructor(color, title, description) {
  //   this.color = color;
  //   this.title = title;
  //   this.description = description;
  // }

  getEventCategory() {
    return this;
  }
}
class SimpleEventList {
  constructor(events = [], builder) {
    this.events = events;
    this.builder = builder;
  }

  /**
   * Get calendar events by day
   * @param {Object} date - momentjs instance or string in yyyy-mm-ddT-00:00+00
   */
  getScheduledEventsByDay(date) {
    if (typeof date === "string") {
      date = moment(date);
    }

    return this.events
      .filter(function (obj) {
        if (!obj.date.isSame(date, "day")) {
          return false;
        }

        return true;
      })
      .sort(function (a, b) {
        return a.valueOf() - b.valueOf();
      });
  }

  /**
   * Add Event to EventList
   * @param {Event} e - { id: #, date: 'yyyy-mm-ddT-00:00+00', title: '' }
   * @param {boolean} refresh - determines if we should refresh the calendar
   */
  addScheduledEvent(e, refresh = true) {
    if (!e["date"] && !e["title"]) {
      return false;
    }

    // Generate a unique id
    // e.id = `${Date.now()}${Math.floor(Math.random() * 100)}`;
    // Uses ID from backend now.
    e.date = moment(e["date"]);

    // console.log(e);
    let newEvent = new SimpleEvent(e.id, e.permalink, e.eventCategories, e.date, e.img, e.dateObj, e.time, e.title, e.excerpt, e.long_excerpt, e.color, e.repeated, e.categories || undefined);
    this.events.push(newEvent);

    // Clears the event properties for filters
    //     this.eventProperties = false;

    if (refresh) {
      this.builder.buildCalendar();
    }

    return true;
  }

  /**
   * Add multiple events to the calendar
   * @param {Object} e - [{ date: 'yyyy-mm-ddT-00:00+00', title: '' }]
   */
  addScheduledEvents(e) {
    for (let i of e) {
      this.addScheduledEvent(i, false);
    }

    this.builder.buildCalendar();
  }

  /**
   * Remove event from calendar
   * @param {Object} e - { date: 'yyyy-mm-ddT-00:00+00', title: '' }
   * @param {boolean} refresh - determines if we should refresh the calendar
   */
  removeScheduledEvent(e, refresh = true) {
    e["date"] = e["date"] ? moment(e["date"]) : "";

    this.events = this.events.filter(function (obj) {
      if (e.date && e.title) {
        if (obj.date.isSame(e.date) && obj.title == e.title) {
          return false;
        }
      }

      if (e.id) {
        if (obj.id === e.id) {
          return false;
        }
      }

      return true;
    });

    // Clears the event properties for filters
    //     this.eventProperties = false;

    if (refresh) {
      this.builder.buildCalendar();
    }

    return true;
  }

  getEventList() {
    return this.events;
  }

  /**
   * @param {Boolean} clearCache determines if we should clear the transposed cache
   * @returns {Object} transposed data
   */
  getTransposedEventProperties(eventProperties, clearCache = false) {
    if (
      (typeof this.events[0] !== "undefined" &&
        !eventProperties &&
        !clearCache) ||
      (typeof this.events[0] !== "undefined" && clearCache)
    ) {
      eventProperties = Object.assign(
        // for each key loop through the data and get the values
        ...Object.keys(this.events[0]).map(
          // function ( key ) {
          //     return {
          //         [key]: this.events.map(
          //                 function ( o ) {
          //                     return o[key]
          //                 }
          //             )
          //     }
          // }
          (key) => ({
            [key]: this.events
              .map((o) => o[key])
              .filter((v, i, a) => a.indexOf(v) === i),
          })
        )
      );

      // eventProperties.filter((v, i, a) => a.indexOf(v) === i);
    }

    return eventProperties;
  }
}
(function () {
  // let template = {
  // master: document.querySelector('#simple-calendar').innerHTML,
  // header: document.querySelector('#simple-calendar-header').innerHTML,
  // dow: document.querySelector('#simple-calendar-dow').innerHTML,
  // day: document.querySelector('#simple-calendar-day').innerHTML,
  // cellEvent: document.querySelector('#simple-calendar-cell-event').innerHTML,
  // cellMore: document.querySelector('#simple-calendar-cell-more').innerHTML,
  // cellPopup: document.querySelector('#simple-calendar-cell-popup').innerHTML,

  // selector: document.querySelector('#simple-calendar-selector').innerHTML,
  // months: document.querySelector('#simple-calendar-selector-months').innerHTML,
  // years: document.querySelector('#simple-calendar-selector-years').innerHTML,

  // filterInput: document.querySelector('#simple-calendar-basic-filter-input').innerHTML,
  // filterOption: document.querySelector('#simple-calendar-basic-filter-options').innerHTML,
  // }
  function template(id) {
    return document.querySelector(`template[data-simple-calendar='${id}']`)
      .innerHTML;
  }

  // let shadowRoot;
  let today = new Date();

  class SimpleCalendarElement extends HTMLElement {
    static get observedAttributes() {
      // "day"
      return ["month", "year", "shift", "exclude", "locale", "maxEvents"];
    }

    constructor() {
      super();
      /* shadowRoot = this.attachShadow({mode: 'open'});  */
      this.hasInitiated = false;
      this.preventDateEventDispatch = false;
      this.dataStore = {
        filter: {},
        view: "monthly",
      };
      this.eventProperties = false;
      this.eventFilters = [];
      // this.eventFilters = [{
      //     name: 'test',
      //     callback: function(events) {
      //         return events.filter((item) => {
      //             // console.log(item);
      //             return item.date.isSame('2021-05-12');
      //         });
      //     }
      // }];
      // this.selectorStateOpen = false;
      // this.eventList = [];
      this.eventList = new SimpleEventList([], this);

      this.breakpoints = {
        md: 768,
      };

      window.addEventListener("resize", (e) => {
        let activePopup = this.querySelector(
          ".simple-calendar-cell-popup-active"
        );

        if (activePopup) {
          let cell = activePopup.closest(".simple-calendar-cell-day");
          activePopup.style.left =
            cell.offsetLeft + cell.offsetWidth / 2 + "px";
        }
      });

      this.addEventListener("mousewheel", (e) => {
        if (
          e.target.classList.contains("simple-calendar-cell-popup-events") ||
          (e.target.closest(".simple-calendar-cell-popup-events") &&
            !e.target.closest(".simple-calendar-cell-events-event-details"))
        ) {
          this.querySelectorAll(
            ".simple-calendar-cell-events-event-details"
          ).forEach(function (item) {
            item.classList.remove(
              "simple-calendar-cell-events-event-details-active"
            );
          });
        }
      });

      this.addEventListener("click", (e) => {

        let tag = e.target.tagName == "A" ? e.target : e.target.closest("a");
        let activePopup = this.querySelector(
          ".simple-calendar-cell-popup-active"
        );

        // If click is not in a popup, clear popup
        if (
          !e.target.closest(".simple-calendar-cell-popup") &&
          !e.target.classList.contains("simple-calendar-cell-popup")
        ) {
          if (activePopup) {
            activePopup.classList.remove("simple-calendar-cell-popup-active");
          }
        }

        // If click is not in preview
        if (
          !e.target.closest(".simple-calendar-cell-events-event-details") &&
          !e.target.classList.contains(
            "simple-calendar-cell-events-event-details"
          )
        ) {
          this.querySelectorAll(
            ".simple-calendar-cell-events-event-details"
          ).forEach(function (item) {
            item.classList.remove(
              "simple-calendar-cell-events-event-details-active"
            );
          });
        }

        // Mobile
        // TODO: delete "if ( document.body.clientWidth > 764 ) {" line
        if (
          window.matchMedia(`(max-width: ${this.breakpoints.md}px)`).matches
        ) {
          var siblings = (n) =>
            [...n.parentElement.children].filter((c) => {
              if (
                c.classList.contains("simple-calendar-cell-popup") &&
                c.classList.contains("simple-calendar-cell-popup-has-events")
              ) {
                c.classList.add("simple-calendar-cell-popup-active");
              }
              return c !== n;
            });
          siblings(e.target);
        }
        // } else {
        // Desktop
        if (
          tag &&
          tag.tagName == "A" &&
          tag.hasAttribute("data-calendar-event")
        ) {
          let dataLink = tag.getAttribute("data-calendar-event");

          if (dataLink == "more") {
            e.preventDefault();

            let cell = tag.closest(".simple-calendar-cell-day"),
              popup = cell.querySelector(".simple-calendar-cell-popup");

            // Clear old popup
            if (activePopup) {
              activePopup.classList.remove("simple-calendar-cell-popup-active");
            }

            // center popup
            popup.style.left = cell.offsetLeft + cell.offsetWidth / 2 + "px";
            popup.classList.add("simple-calendar-cell-popup-active");
          } else {
            e.preventDefault();

            let tag = e.target.classList.contains(
              "simple-calendar-cell-events-event"
            )
              ? e.target
              : e.target.closest(".simple-calendar-cell-events-event");
            this.querySelectorAll(
              ".simple-calendar-cell-events-event-details"
            ).forEach(function (item) {
              item.classList.remove(
                "simple-calendar-cell-events-event-details-active"
              );
            });

            if (tag) {
              const el = tag.querySelector(
                ".simple-calendar-cell-events-event-details"
              );
              const popup = tag.closest(".simple-calendar-cell-popup-events");

              if (popup !== null)
                el.style.top =
                  (popup ? tag.offsetTop - popup.scrollTop : tag.offsetTop) +
                  "px";

              if (
                window.matchMedia(`(min-width: ${this.breakpoints.md + 1}px)`)
                  .matches
              ) {
                //document.body.clientWidth > 764 ) {
                // const popupWrapper = popup.closest(".simple-calendar-cell-popup");
                const wrapper = popup
                  ? popup.closest(".simple-calendar-cell-popup")
                  : el.closest(".simple-calendar-cell");

                if (wrapper.offsetLeft > document.body.clientWidth / 2) {
                  // console.log("left");
                } else {
                  // console.log("right");
                  el.classList.add(
                    "simple-calendar-cell-events-event-details-right"
                  );
                }
              } else {
                // Mobile adjustments needs to be made
                // console.log("center");
                let closeButton = el.querySelector(
                  ".simple-calendar-cell-events-event-details-close"
                );

                if (
                  window.matchMedia(`(min-width: 1200px)`).matches
                ) {
                  closeButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    el.classList.remove(
                      "simple-calendar-cell-events-event-details-active"
                    );
                  });
                }
              }

              el.classList.add(
                "simple-calendar-cell-events-event-details-active"
              );
            }
          }
        }

        let btnTag = e.target.tagName == "BUTTON" ? e.target : e.target.closest("button");
        const prevBtn = this.querySelector('button[data-calendar-selector="month-prev"]');
        const nextBtn = this.querySelector('button[data-calendar-selector="month-next"]');

        if (
          btnTag &&
          btnTag.tagName == "BUTTON" &&
          btnTag.hasAttribute("data-calendar-selector")
        ) {

          btnTag.disabled = true;
          console.log(btnTag);
          let dataLink = btnTag.getAttribute("data-calendar-selector");

          if (dataLink == 'month-prev' || dataLink == 'month-next') {
            this.preventDateEventDispatch = true;

            let year = this.getYear();
            let month = this.getMonth(); // 0-based: Jan = 0, Dec = 11

            if (dataLink === 'month-prev') {
              if (month === 0) {
                year -= 1;
                month = 11;
              } else {
                month -= 1;
              }
            }

            if (dataLink === 'month-next') {
              if (month === 11) {
                year += 1;
                month = 0;
              } else {
                month += 1;
              }
            }

            this.pendingChange = [year, month];

            this.dispatchEvent(new CustomEvent('dateChange', {
              detail: { date: this.pendingChange }
            }));

            this.setAttribute("year", year);
            this.setAttribute("month", month);

            // Disable buttons if at bounds
            // const minYear = this.getMinYear();
            const minYear = 2025;
            const maxYear = this.getMaxYear();


            if (dataLink === 'month-prev' && year <= minYear && month === 1) {
              prevBtn.disabled = true;
            } else if (dataLink === 'month-next' && year >= maxYear && month === 11) {
              nextBtn.disabled = true;
            } else {
              prevBtn.disabled = false;
              nextBtn.disabled = false;
            }

            this.preventDateEventDispatch = false;
          }



          if (dataLink == "open") {
            e.preventDefault();
            this.dispatchEvent(new CustomEvent("selector--open", {}));
          }
        }

        if (
          tag &&
          tag.tagName == "A" &&
          tag.hasAttribute("data-calendar-selector")
        ) {
          let dataLink = tag.getAttribute("data-calendar-selector");

          if (dataLink == "open") {
            e.preventDefault();
            this.dispatchEvent(new CustomEvent("selector--open", {}));
          }
        } else {
          this.dispatchEvent(new CustomEvent("selector--close", {}));
        }
      });
    }

    connectedCallback() {
      this.buildCalendar();
      this.hasInitiated = true;

      this.dispatchEvent(new CustomEvent("init", {}));
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
      if (this.hasInitiated) {
        // Trigger different events
        if (attrName == "month" && !this.preventDateEventDispatch) {
          this.dispatchEvent(
            new CustomEvent("dateChange", {
              date: [this.getYear(), newVal],
            })
          );
        } else if (attrName == "year" && !this.preventDateEventDispatch) {
          this.dispatchEvent(
            new CustomEvent("dateChange", {
              date: [newVal, this.getMonth()],
            })
          );
        } else if (attrName == "day" && !this.preventDateEventDispatch) {
          // console.log("tried to change day");
        } else if (attrName == "locale") {
          this.dispatchEvent(
            new CustomEvent("languageChange", {
              locale: newVal,
            })
          );
        } else if (attrName == "month" || attrName == "year") {
          // do nothing here to prevent dates change from dispatching
        } else {
          this.dispatchEvent(
            new CustomEvent("settingChange", {
              attrName: attrName,
              oldVal: oldVal,
              newVal: newVal,
            })
          );
        }

        this.buildCalendar();
      }
    }

    builder(element, html) {
      let locale = this.getLocale();
      let momentDefaultLanguage = moment.locale();

      moment.locale(locale);
      element.innerHTML = html;
      moment.locale(momentDefaultLanguage);
    }

    /*
    * Rebuild the calendar on view change, this stops the pop-up from existing.
    */
    changeDataStoreView(view) {
      this.dataStore.view = view;
      this.buildCalendar();
    }

    buildCalendar() {
      let dom = {};
      dom.header = this.generateHeader();
      dom.calendarDaysOfWeek = this.generateDOW();
      dom.calendarDays = this.generateDays();
      // dom.mobileModal = this.generateModal();

      this.builder(this, this.parseTemplate("master", dom));

      if (this.dataStore.view === "monthly") {
        document
          .querySelector(".simple-calendar")
          .classList.remove("list-view");

        [
          ...document.querySelectorAll(
            ".simple-calendar-cell-events-event-monthly"
          ),
        ].forEach(function (item) {
          item.classList.remove("hidden");
        });
        [
          ...document.querySelectorAll(
            ".simple-calendar-cell-events-event-list"
          ),
        ].forEach(function (item) {
          item.classList.add("hidden");
        });
      } else {
        document.querySelector(".simple-calendar").classList.add("list-view");

        [
          ...document.querySelectorAll(
            ".simple-calendar-cell-events-event-monthly"
          ),
        ].forEach(function (item) {
          item.classList.add("hidden");
        });
        [
          ...document.querySelectorAll(
            ".simple-calendar-cell-events-event-list"
          ),
        ].forEach(function (item) {
          item.classList.remove("hidden");
        });
      }

      let theDataStore = this.dataStore;
      let thisClass = this;

      [
        ...document.querySelectorAll(".simple-calendar-header-options-option"),
      ].forEach(function (item) {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          const classList = item.classList;
          if (
            classList.contains("simple-calendar-header-options-option-monthly")
          ) {
            [
              ...document.querySelectorAll(
                ".simple-calendar-cell-events-event-monthly"
              ),
            ].forEach(function (item) {
              item.classList.remove("hidden");
            });
            [
              ...document.querySelectorAll(
                ".simple-calendar-cell-events-event-list"
              ),
            ].forEach(function (item) {
              item.classList.add("hidden");
            });

            document
              .querySelector(".simple-calendar")
              .classList.remove("list-view");
            thisClass.changeDataStoreView("monthly");
          }
          if (
            classList.contains("simple-calendar-header-options-option-list")
          ) {
            [
              ...document.querySelectorAll(
                ".simple-calendar-cell-events-event-monthly"
              ),
            ].forEach(function (item) {
              item.classList.add("hidden");
            });
            [
              ...document.querySelectorAll(
                ".simple-calendar-cell-events-event-list"
              ),
            ].forEach(function (item) {
              item.classList.remove("hidden");
            });

            document
              .querySelector(".simple-calendar")
              .classList.add("list-view");

            thisClass.changeDataStoreView("list");
          }
        });
      });
    }

    buildSelector() {
      this.builder(this, this.parseTemplate("selector", ""));
    }

    // generateModal( returnable = 'html' ) {
    //     let result = returnable == 'json' ? [] : '';
    //     // let year = this.getYear(), month = this.getMonth();

    //     // Updates the date value just in case
    //     // today = new Date();

    //     // let date = moment( [year, month] );

    //     if ( returnable == "json" ) {
    //         // result.push({
    //         //     date: date
    //         // });
    //     } else {
    //         result += this.parseTemplate( 'mobileModal', {
    //             // date: date,
    //             this: this
    //         });
    //     }

    //     return result;
    // }

    generateHeader(returnable = "html") {
      let result = returnable == "json" ? [] : "";
      let year = this.getYear(),
        month = this.getMonth();

      // Updates the date value just in case
      today = new Date();

      let date = moment([year, month]);

      if (returnable == "json") {
        result.push({
          date: date,
        });
      } else {
        result += this.parseTemplate("header", {
          date: date,
          this: this,
        });
      }

      return result;
    }

    generateDOW(returnable = "html") {
      let result = returnable == "json" ? [] : "";
      let shiftDay = this.getCalendarShift();

      let daySelector = shiftDay;
      let days = moment.weekdays();
      let dayFormat = { long: days, short: moment.weekdaysShort() };

      let exclude = this.getExcludedDOW();
      let numberOfCells = 7 - exclude.length;

      for (let day_of_week = 0; day_of_week <= 6; day_of_week++) {
        if (daySelector >= days.length) {
          daySelector = 0;
        } else if (daySelector < 0) {
          daySelector = days.length - 1 + shiftDay;
        }

        if (!exclude || !exclude.includes(daySelector)) {
          if (returnable == "json") {
            result.push({
              day: daySelector,
              formats: dayFormat,
              numberOfCells: numberOfCells,
            });
          } else {
            result += this.parseTemplate("dow", {
              day: daySelector,
              formats: dayFormat,
              numberOfCells: numberOfCells,
              this: this,
            });
          }
        }

        daySelector++;
      }

      return result;
    }

    generateDays(returnable = "html") {
      let result = returnable == "json" ? [] : "";
      let shiftDay = this.getCalendarShift(),
        year = this.getYear(),
        month = this.getMonth();
      let exclude = this.getExcludedDOW();
      let numberOfCells = 7 - exclude.length;
      let eventsPerDay = this.getEventsPerDay();

      // Updates the date value just in case
      today = new Date();

      let date = moment([year, month]);

      let number_of_days = date.daysInMonth();
      let start_date = date.day();
      let dayOfMonth = "";
      let currentDay;

      let events = false;
      let eventsHTML = false;
      let popupHTML = false;

      let calendarCellStartNumber = start_date - shiftDay;

      if (calendarCellStartNumber < 0) {
        calendarCellStartNumber = 7 + calendarCellStartNumber;
      }

      for (var cell = 0; cell < 42; cell++) {
        if (
          cell >= calendarCellStartNumber &&
          cell <= calendarCellStartNumber + number_of_days - 1
        ) {
          dayOfMonth = cell - calendarCellStartNumber + 1;
          currentDay = moment([year, month, dayOfMonth]);
        } else {
          dayOfMonth = "";

          if (cell < calendarCellStartNumber) {
            currentDay = moment([year, month, 1]).subtract(
              Math.abs(cell - calendarCellStartNumber),
              "d"
            );
          } else {
            currentDay = moment([year, month, number_of_days]).add(
              Math.abs(cell - number_of_days - calendarCellStartNumber + 1),
              "d"
            );
          }
        }

        if (!exclude || !exclude.includes(currentDay.day())) {
          events = this.filterEvents(
            this.eventList.getScheduledEventsByDay(currentDay)
          );

          eventsHTML = "";
          popupHTML = "";

          for (let event in events) {
            popupHTML += this.parseTemplate("cellEvent", events[event]);

            if (this.dataStore.view === "monthly") {
              if (event == eventsPerDay) {
                eventsHTML += this.parseTemplate("cellMore", {
                  events: events,
                  eventsPerDay: eventsPerDay,
                });
              } else if (event < eventsPerDay) {
                eventsHTML += this.parseTemplate("cellEvent", events[event]);
              }
            } else {
              eventsHTML += this.parseTemplate("cellEvent", events[event]);
            }
          }

          if (returnable == "json") {
            result.push({
              dayOfMonth: dayOfMonth,
              cell: cell,
              isToday: dayOfMonth ? currentDay.isSame(moment(), "day") : false,
              numberOfCells: numberOfCells,
              cellLocation:
                (cell + 1) % numberOfCells == 0
                  ? "end"
                  : (cell + 1) % numberOfCells == 1
                    ? "start"
                    : "middle",
              date: currentDay,
              events: events,
              eventsHTML: eventsHTML,
              popupHTML: popupHTML,
              hasEvents: events.length > 0 ? true : false,
            });
          } else {
            result += this.parseTemplate("day", {
              dayOfMonth: dayOfMonth,
              cell: cell,
              isToday: dayOfMonth ? currentDay.isSame(moment(), "day") : false,
              numberOfCells: numberOfCells,
              cellLocation:
                (cell + 1) % numberOfCells == 0
                  ? "end"
                  : (cell + 1) % numberOfCells == 1
                    ? "start"
                    : "middle",
              date: currentDay,
              events: events,
              eventsHTML: eventsHTML,
              popupHTML: popupHTML,
              hasEvents: events.length > 0 ? true : false,
              this: this,
            });
          }
        }

        // Should we add another row?
        if (
          (cell + 1) % numberOfCells == 0 &&
          cell >= calendarCellStartNumber + number_of_days - 1
        ) {
          break;
        }
      }

      return result;
    }

    // parseTemplate(part, data = {}) {
    //   // var templateElement = document.createElement('div');
    //   // templateElement.innerHTML = eval('`'+template[ part ]+'`').trim();
    //   // console.log(template[ part ]);

    //   var code = document.createElement("textarea");
    //   code.innerHTML = template(part);
    //   // console.log(eval('`'+code.value+'`').trim())
    //   // console.log(code.value, part);
    //   return eval("`" + code.value + "`").trim();
    // }

    parseTemplate(part, data = {}) {
      // console.log('Template Part:', part);
      // console.log('Template Data:', data);

      var code = document.createElement("textarea");
      code.innerHTML = template(part);

      // console.log('Template Code:', code.value);

      try {
        return eval("`" + code.value + "`").trim();
      } catch (error) {
        console.error('Error evaluating template:', error);
        return '';
      }
    }

    getMinYear() {
      let year = parseInt(this.getAttribute("minyear"));
      return year > 0 ? year : false;
    }

    getMaxYear() {
      let year = parseInt(this.getAttribute("maxYear"));
      return year > 0 ? year : false;
    }

    getYear(customYear = false) {
      let year = parseInt(this.getAttribute("year"));

      if (customYear) {
        year = customYear;
      }

      if (year === false) {
        year = today.getFullYear();
      }

      // Just give a warning, even though js supports big ranges
      if (year <= 999) {
        console.warn(
          `Simple Calendar: Year is less than or equal to 999. The calendar expects a 4 digit year.`
        );
      } else if (year > 9999) {
        console.warn(
          `Simple Calendar: Year is greater than 9999. The calendar expects a 4 digit year.`
        );
      }

      return parseInt(year);
    }

    getMonth(customMonth = false) {
      let month = parseInt(this.getAttribute("month"));

      if (customMonth) {
        month = customMonth;
      }

      if (month === false) {
        month = today.getMonth();
      }

      // Don't allow wrong values entered here.
      if (month < 0) {
        console.warn(
          `Simple Calendar: Month is less than 0. The month should be a number between 0 - 11. Given ${month}. Assumed 0.`
        );
        return 0;
      } else if (month > 11) {
        console.warn(
          `Simple Calendar: Month is greater than 11. The month should be a number between 0 - 11. Given ${month}. Assumed 11.`
        );
        return 11;
      }

      return parseInt(month);
    }

    // getDay(customDay = false) {
    //   let day = parseInt(this.getAttribute("day"));

    //   if (customDay) {
    //     day = customDay;
    //   }

    //   if (day === false) {
    //     day = today.getDay();
    //   }

    //   // Don't allow wrong values entered here.
    //   if (day < 0) {
    //     console.warn(
    //       `Simple Calendar: Day is less than 0. The day should be a number between 0 - 31. Given ${day}. Assumed 0.`
    //     );
    //     return 0;
    //   } else if (day > 31) {
    //     console.warn(
    //       `Simple Calendar: Day is greater than 31. The day should be a number between 0 - 31. Given ${day}. Assumed 0.`
    //     );
    //     return 0;
    //   }

    //   return parseInt(day);
    // }

    getCalendarShift() {
      let shiftDay = parseInt(this.getAttribute("shift")) || 0;

      // Don't allow wrong values entered here.
      if (shiftDay > 6) {
        console.warn(
          `Simple Calendar: Shift should be a number between 0 - 6. Given ${shiftDay}. Assumed value 6.`
        );
        return 6;
      } else if (shiftDay < 0) {
        console.warn(
          `Simple Calendar: Shift should be a number between 0 - 6. Given ${shiftDay}. Assumed value 0.`
        );
        return 0;
      }

      return shiftDay;
    }

    getExcludedDOW() {
      let exclude = this.getAttribute("exclude") || "";

      if (exclude) {
        exclude = exclude
          .split(",")
          .map(function (e) {
            return parseInt(e.trim());
          })
          .filter(function (item, pos, self) {
            if (item > 6 || item < 0) {
              console.warn(
                `Simple Calendar: ${item} is not a valud excludable day.`
              );
              return false;
            }

            return self.indexOf(item) == pos;
          });
      }

      return exclude;
    }

    getEventsPerDay() {
      let number = parseInt(this.getAttribute("maxEvents")) || 3;
      return number;
    }

    getLocale(customLocale = false) {
      let locale = this.getAttribute("locale") || "en";
      let scripts = document.getElementsByTagName("script");
      let loadLang = true;
      let momentDir = "";

      if (customLocale) {
        locale = customLocale;
      }

      // en is the default so no need to load it
      if (locale == "en") {
        return locale;
      }

      // Check to see if we should force load the language
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute("src").includes(`moment.js`)) {
          momentDir = scripts[i].getAttribute("src").slice(0, -9);
        }

        if (
          scripts[i].getAttribute("src").includes(`moment/locale/${locale}.js`)
        ) {
          loadLang = false;
        }
      }

      if (loadLang) {
        // Force load the language (better to do this through WP though)
        var scriptElement = document.createElement("script");
        scriptElement.src = `${momentDir}locale/${locale}.js`;
        scriptElement.onload = function () {
          // Force rebuild of all calendars using this language
          let list = document.getElementsByTagName("simple-calendar");
          for (let item of list) {
            if (item.getAttribute("locale") == locale) {
              item.buildCalendar();
            }
          }
        };
        document.body.appendChild(scriptElement);
      }

      return locale;
    }

    /**
     * Add event to calendar
     * @param {Object} e - { date: 'yyyy-mm-ddT-00:00+00', title: '' }
     * @param {boolean} refresh - determines if we should refresh the calendar
     */
    addScheduledEvent = (e, refresh = true) =>
      this.eventList.addScheduledEvent(e, refresh);

    /**
     * DEPRECATED: Add multiple events to the calendar
     * @param {Object} e - [{ date: 'yyyy-mm-ddT-00:00+00', title: '' }]
     */
    addScheduledEvents = (e) => this.eventList.addScheduledEvent(e);

    /**
     * Remove event from calendar
     * @param {Object} e - { date: 'yyyy-mm-ddT-00:00+00', title: '' }
     * @param {boolean} refresh - determines if we should refresh the calendar
     */
    // Clears the event properties for filters
    // this.eventProperties = false;
    // ^^ Is this needed?
    removeScheduledEvent = (e, refresh = true) =>
      this.eventList.removeScheduledEvent(e, refresh);

    /**
     * Get calendar events
     */
    getScheduledEvents = () => this.eventList.getEventList();

    /**
     * Get calendar events by day
     * @param {Object} date - momentjs instance or string in yyyy-mm-ddT-00:00+00
     */
    getScheduledEventsByDay = (date) =>
      this.eventList.getScheduledEventsByDay(date);

    /**
     * @param {Boolean} clearCache determines if we should clear the transposed cache
     * @returns {Object} transposed data
     */
    getTransposedEventProperties = (clearCache = false) =>
      this.eventList.getTransposedEventProperties(
        this.eventProperties,
        clearCache
      );

    /**
     * Filter Events
     * @param {Array} events - array of event objects
     */
    filterEvents(events) {
      //  console.log(this.eventFilters , typeof this.eventFilters , this.eventFilters.length > 0)
      if (
        this.eventFilters &&
        typeof this.eventFilters === "object" &&
        this.eventFilters.length > 0
      ) {
        this.eventFilters.forEach(function (filter) {
          if (
            typeof filter === "object" &&
            typeof filter.callback === "function"
          ) {
            events = filter.callback(events);
          }
        });
      }

      return events;
    }

    /**
     * Add filter
     * @param {String} name - unique filter string
     * @param {Function} callback - callback function to use for filtering events
     */
    addEventFilter(name, callback, data = false) {
      let uniqueSearch = this.eventFilters.filter(function (item) {
        return item.name == name;
      }).length;
      if (name && uniqueSearch === 0 && typeof callback === "function") {
        this.eventFilters.push({
          name: name,
          callback: callback,
          data: data,
        });
        return true;
      } else if (uniqueSearch !== 0) {
        console.warn(
          `Simple Calendar: The filter name must be unique. ${name} is already a filter.`
        );
      } else if (!name) {
        console.warn(`Simple Calendar: Please provide a unique filter name.`);
      } else {
        console.warn(`Simple Calendar: A callback function must be set.`);
      }

      // console.log("filters", this.eventFilters)

      return false;
    }

    /**
     * Remove filter
     * @param {String} name - unique filter string
     */
    removeEventFilter(name) {
      this.eventFilters = this.eventFilters.filter(function (obj) {
        if (obj.name === name) {
          return false;
        }

        return true;
      });
    }

    /**
     * Get filters
     */
    getEventFilters() {
      return this.eventFilters;
    }

    /**
     * Get filter
     * @param {String} name - unique filter string
     */
    getEventFilter(name) {
      return this.eventFilters.filter(function (item) {
        return item.name == name;
      });
    }
  }

  customElements.define("simple-calendar", SimpleCalendarElement);
})();
